import { loadAllLeadersActionCreator } from '@ms/yammer-data/dist/domains/leadersManagement/loadAllLeadersActions';
import type { LoadAllLeadersInUsersNetworkRequestOptions } from '@ms/yammer-data/dist/domains/leadersManagement/sharedAllLeaders';
import { isEventsPage } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadAllLeadersOptions = Omit<LoadAllLeadersInUsersNetworkRequestOptions, 'endCursor'> & {
  // Temporary fix, remove skipApiCall option when resolving this bug ticket:
  // https://yammer.visualstudio.com/engineering/_workitems/edit/365714
  readonly skipApiCall?: boolean;
};
type UseLoadAllLeaders = (options: UseLoadAllLeadersOptions) => void;
export const useLoadAllLeaders: UseLoadAllLeaders = (options) => {
  const dispatch = useDispatch();
  const {
    leadersCount,
    includeUserCoverImageFields,
    includeViewerIsFollowing,
    filterBy,
    sortBy,
    includeLeaderAudiences,
    skipApiCall,
  } = options;
  const isLiveEventPage = isEventsPage(window.location.pathname);

  useEffect(() => {
    if (isLiveEventPage || skipApiCall) {
      return;
    }

    dispatch(
      loadAllLeadersActionCreator({
        endCursor: null,
        leadersCount,
        includeUserCoverImageFields,
        includeViewerIsFollowing,
        filterBy,
        sortBy,
        includeLeaderAudiences,
      })
    );
  }, [
    dispatch,
    leadersCount,
    includeUserCoverImageFields,
    includeViewerIsFollowing,
    filterBy,
    sortBy,
    includeLeaderAudiences,
    isLiveEventPage,
    skipApiCall,
  ]);
};
